import { createContext, useContext, useEffect } from 'react';
export const StepperContext = createContext(null);
export const useStepper = () => {
    return useContext(StepperContext);
};
export const useStep = ({ step, icon, label, invalid, loading, hideControl, disabled }) => {
    const { setStep, current, setNext, setPrevious, isSubmitting } = useContext(StepperContext);
    useEffect(() => {
        setStep({
            step,
            icon,
            label,
            invalid,
            hideControl,
            loading,
            disabled,
        });
        // Eslint disabled pour optimisation et boucle infini. Faire attention à ajouter manuellement les properties nécessaires
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invalid, label, loading, hideControl, disabled]);
    return { current, setPrevious, setNext, isSubmitting };
};
